<template>
    <v-col
        cols="12"
        md="10"
        offset-md="1"
    >
        <v-row>
            <v-col>
                <p class="text-h6 font-weight-light text-center">
                    Hier ist eine beispielhafte Darstellung von Projekten, die von ehemaligen Teilnehmenden von Aktion Zukunft initiiert wurden:
                </p>
            </v-col>
        </v-row>
        <v-row>
            <v-col
                v-for="(project, index) in projects"
                :key="index"
                cols="12" 
                sm="6"
            >
                <Card
                    :elements="project.content"
                    medium
                    style="height: 100%;"
                    class="bg-alpha-white"
                />
            </v-col>
        </v-row>
    </v-col>
</template>

<script>
import Card from "@/components/Card/Card.vue";

export default {
    components: {
        Card
    },
    data: () => ({
        projects: [
            {
                id: 1,
                content: [
                    {
                        type: "image",
                        src: "projekte/pink_key",
                        fileTypes: ["webp", "jpg"],
                        aspectRatio: 1.77777777
                    },
                    {
                        type: "title",
                        text: "The Pink Key",
                        noDivider: true
                    },
                    {
                        type: "text",
                        text: `Das Projekt „The Pink Key" richtet sich an geflüchtete 
                        Frauen, die unter Anleitung unserer Aktion Zukunft Alumna Aya, 
                        die deutsche Sprache spielerisch erlernen. Dabei befassen sie 
                        sich mit unterschiedlichen Themengebieten zu denen sie Theaterstücke 
                        entwickeln. Durch das Schauspielern verwenden die Teilnehmerinnen 
                        den erlernten Wortschatz in verschiedenen Situationen, wodurch 
                        es Ihnen auch im Alltag leichter fallen soll, das Gelernte anzuwenden.`
                    }
                ]
            },
            {
                id: 2,
                content: [
                    {
                        type: "image",
                        src: "projekte/nachhilfe",
                        fileTypes: ["webp", "jpg"],
                        aspectRatio: 1.77777777,
                        position: "top center"
                    },
                    {
                        type: "title",
                        text: "Deutschnachhilfe für Schüler*innen mit Flucht- oder Migrationshintergrund",
                        noDivider: true
                    },
                    {
                        type: "text",
                        text: `Das Projekt ,,Deutschnachhilfe für Schüler*innen mit Flucht- oder 
                        Migrationshintergrund” ermöglicht Kindern außerhalb des Unterrichts 
                        unter Anleitung älterer Schüler*innen bei Hausaufgaben unterstützt 
                        und in Deutsch gefördert zu werden. Spielerisch entwickeln sie ein 
                        Gefühl für die Sprache und können sich auch gegenseitig beim Lernen 
                        zur Seite stehen.`
                    }
                ]
            },
            {
                id: 3,
                content: [
                    {
                        type: "image",
                        fileTypes: ["webp", "jpg"],
                        src: "projekte/kocht_ellwangen",
                        aspectRatio: 1.77777777
                    },
                    {
                        type: "title",
                        text: "StF-Kocht Ellwangen",
                        noDivider: true
                    },
                    {
                        type: "text",
                        text: `Das Projekt STF-Kocht in Ellwangen wurde vor zwei Jahren mit 
                        Hilfe von Aktion Zukunft 2018 und One Future e.V. von drei 
                        Schülerinnen aus Ellwangen ins Leben gerufen. Ziel war es, durch 
                        Kochen einen Rahmen für kulturellen Austausch zwischen Geflüchteten 
                        aus der ortsansässigen Erstaufnahmestelle und Schüler*innen zu 
                        schaffen. Es wurde alle zwei Monate mit rund 7 bis 14 Geflüchteten 
                        im Alter von 14 bis 42 Jahren und ca. 9 Mitschüler*innen zusammen 
                        gekocht.`
                    }
                ]
            },
            {
                id: 4,
                content: [
                    {
                        type: "image",
                        src: "projekte/cafe_international",
                        fileTypes: ["webp", "jpg"],
                        aspectRatio: 1.77777777,
                        filters: {
                            blur: "2px"
                        }
                    },
                    {
                        type: "title",
                        text: "Café International und Nachhilfe",
                        noDivider: true
                    },
                    {
                        type: "text",
                        text: `Das Projekt Café International und Nachhilfe bietet geflüchteten 
                        Familien den Raum zum Kennenlernen Anderer während sie dabei ihre 
                        Deutschkenntnisse verbessern können. Dazu treffen sich einmal im Monat 
                        einheimische Familien und Schüler*innen im Gemeindehaus der Stadt.`
                    }
                ]
            }
        ]
    })
}
</script>